<kendo-dialog title="Add Student to Waitlist" *ngIf="showSearchModal" (close)="onHideHandler()" maxHeight="85vh"
  width="80vw" [minHeight]="300" [animation]="{ duration: 300, type: 'fade', direction: 'down' }">
  <div class="search-instructions">
    Please enter the student’s first name, last name, Student ID, and date of
    birth to proceed.
  </div>

  <form [formGroup]="searchFormGroup">
    <div class="waitList-form">
      <kendo-formfield class="flex-element">
        <kendo-floatinglabel text="Student First Name *">
          <kendo-textbox #firstName size="large" rounded="large" formControlName="firstName">
          </kendo-textbox>
        </kendo-floatinglabel>
      </kendo-formfield>

      <kendo-formfield class="flex-element">
        <kendo-floatinglabel text="Student Last Name *">
          <kendo-textbox #lastName size="large" rounded="large" formControlName="lastName">
          </kendo-textbox>
        </kendo-floatinglabel>
      </kendo-formfield>

      <kendo-formfield class="flex-element">
        <kendo-floatinglabel text="Student ID *">
          <kendo-numerictextbox format="##" #nycId size="large" [maxlength]="9" rounded="large" formControlName="nycId"
            [spinners]="false">
          </kendo-numerictextbox>
        </kendo-floatinglabel>
        <kendo-formhint>Student ID should be 9 digits</kendo-formhint>
      </kendo-formfield>

      <kendo-formfield class="flex-element">
        <kendo-floatinglabel text="Date of Birth *">
          <kendo-datepicker calendarType="classic" rounded="large" formControlName="birthDate" placeholder="MM/DD/YYYY"
            [format]="format"></kendo-datepicker>
        </kendo-floatinglabel>
      </kendo-formfield>

      <button kendoButton class="search-button btn-size" themeColor="primary" type="button" rounded="large"
        fillMode="solid" (click)="studentSearch()" [disabled]="searchFormGroup.invalid">
        Search
      </button>
    </div>
  </form>
  <div class="loading-container" *ngIf="loadSpinner">
    <kendo-loader type="converging-spinner" size="large"></kendo-loader>
  </div>
  <div *ngIf="showResults" class="waitList-form">
    <p>
      Please review the following students and select the student you would like
      to add to your waitlist.
    </p>
    <form [formGroup]="gridFormGroup">
      <kendo-grid class="student-search-grid" [kendoGridBinding]="students" scrollable="none" [pageSize]="10"
        [pageable]="false" [sortable]="false" [groupable]="false" [resizable]="false"
        [columnMenu]="{ filter: false, columnChooser: false }" [selectable]="false" [navigable]="true">
        <kendo-grid-column field="studentName" title="Student" [width]="150">
          <ng-template kendoGridCellTemplate let-data>
            <div class="name-container">
              <div class="student-name k-text-ellipsis">
                <b> {{ data?.firstName }} {{ data?.lastName }}</b>
              </div>
              <div>
                <p>{{ data?.nycid }}</p>
              </div>
            </div>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="dateOfBirthUnixTimestamp" title="DOB" [width]="150" [resizable]="false">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            {{ dataItem.birthDate | date : "MM/dd/yyyy" }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="activity" title="Activity" [width]="150" [resizable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            <p>{{ dataItem?.activity }}</p>
          </ng-template>
        </kendo-grid-column>

        <!-- Column with Dropdown List -->
        <kendo-grid-column field="status" title="Site Name" [width]="150">
          <ng-template kendoGridCellTemplate let-dataItem>
            <kendo-formfield>
              <kendo-dropdownlist [data]="agencyList" [textField]="'text'" [valueField]="'value'"
                formControlName="siteName">
              </kendo-dropdownlist>
              <kendo-formerror>Error: Field is required</kendo-formerror>
            </kendo-formfield>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="" title="Actions" [width]="100" headerClass="action-column">
          <ng-template kendoGridCellTemplate let-data>
            <div class="name-container" style="margin-left: 94px">
              <button class="btn-style" (click)="addMdeWaitlist(data)" kendoButton themeColor="primary"
                [disabled]="gridFormGroup.invalid" kendoGridFocusable>
                Add
              </button>
            </div>
          </ng-template>
          <ng-template kendoGridNoRecordsTemplate>
            <p *ngIf="students?.length === 0">No Student records available</p>
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </form>
  </div>
</kendo-dialog>